"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
const SearchBar_1 = __importDefault(require("../components/SearchBar"));
const FilteringDropDown_1 = __importDefault(require("../components/FilteringDropDown"));
const AlphabeticalPagination_1 = __importDefault(require("../components/AlphabeticalPagination"));
const lodash_1 = __importDefault(require("lodash"));
const GodkjenteKontrollanter = (props) => {
    const [filterString, setFilterString] = (0, react_1.useState)("");
    const [selectedRight, setSelectedRight] = (0, react_1.useState)("");
    const [letterFilter, setLetterFilter] = (0, react_1.useState)("");
    const [selectedAuthorization, setSelectedAuthorization] = (0, react_1.useState)("");
    const filteredList = filterString
        ? props.kontrollanter.filter((kontrollant) => mapKontrollantToFilterableString(kontrollant)
            .toLowerCase()
            .includes(filterString.toLowerCase()))
        : props.kontrollanter;
    const autorisasjoner = (0, lodash_1.default)(props.kontrollanter)
        .flatMap((x) => x.authorizationList)
        .map((x) => x.trim())
        .uniq()
        .sort()
        .value();
    const rettigheter = (0, lodash_1.default)(props.kontrollanter)
        .flatMap((x) => x.rightsList)
        .map((x) => x.trim())
        .uniq()
        .sort()
        .value();
    const filteringCriteria = [
        {
            // The value to filter with
            value: selectedRight,
            // A function targeting the list that should be filtered
            mapToArray: (kontrollant) => kontrollant.rightsList,
        },
        {
            value: selectedAuthorization,
            mapToArray: (kontrollant) => kontrollant.authorizationList,
        },
    ].filter((x) => !!x.value);
    /**
     * Every dropdown filter applied by the user is checked against the list of "Kontrollanter".
     */
    const categoryLists = filteringCriteria.reduce((acc, kontrollant) => acc.filter((x) => kontrollant.mapToArray(x).includes(kontrollant.value)), filteredList);
    const filteredForCategories = categoryLists.filter((f) => f.lastName.toUpperCase().startsWith(letterFilter));
    const handleSearch = (event, inputQuery) => {
        event.preventDefault();
        setFilterString(inputQuery);
    };
    const emptyResult = () => {
        if (filteredForCategories.length === 0) {
            return "Ingen resultater, prøv et annet filter";
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "row m-article-list", children: [(0, jsx_runtime_1.jsx)("div", { className: "col-12 col-lg-10 offset-lg-1 mb-5", children: (0, jsx_runtime_1.jsxs)("div", { className: "m__article-list-filter a-background-box a-background-box--blue", children: [(0, jsx_runtime_1.jsx)(SearchBar_1.default, { value: filterString, onChange: setFilterString, onSubmit: (e, inputQuery) => handleSearch(e, inputQuery), onReset: (e) => handleSearch(e, "") }), (0, jsx_runtime_1.jsxs)("div", { className: "dropdown-row", children: [(0, jsx_runtime_1.jsx)(FilteringDropDown_1.default, { categories: autorisasjoner, selectedCategory: selectedAuthorization, setNewCategory: setSelectedAuthorization, labels: {
                                        dropdownLabel: "Autorisasjoner",
                                        allCategoriesNames: "Alle autorisasjoner",
                                    } }), (0, jsx_runtime_1.jsx)(FilteringDropDown_1.default, { categories: rettigheter, selectedCategory: selectedRight, setNewCategory: setSelectedRight, labels: {
                                        dropdownLabel: "Rettigheter",
                                        allCategoriesNames: "Alle rettigheter",
                                    } })] }), (0, jsx_runtime_1.jsx)("div", { className: "paginations", children: (0, jsx_runtime_1.jsx)(AlphabeticalPagination_1.default, { filterLetter: letterFilter, setNewLetterFilter: setLetterFilter, categoryList: categoryLists }) })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "col-12 col-lg-8 offset-lg-2", children: filteredForCategories.map((kontrollant, index) => displayKontrollant(kontrollant, index)) }), (0, jsx_runtime_1.jsx)("div", { className: "mr-auto ml-auto", children: emptyResult() })] }));
};
const mapKontrollantToFilterableString = (k) => {
    return [
        k.firstName,
        k.lastName,
        k.authorizationList.join(";;"),
        k.rightsList.join(";;"),
        k.email,
        k.phoneNumber,
        k.kontrollantId,
    ].join(";;");
};
const displayKontrollant = (kontrollant, index) => {
    var _a, _b, _c, _d;
    const kontrollantId = (_a = kontrollant.kontrollantId) !== null && _a !== void 0 ? _a : index;
    const fullName = kontrollant.lastName + ", " + kontrollant.firstName;
    const phoneNumber = (_b = kontrollant.phoneNumber) !== null && _b !== void 0 ? _b : "";
    const email = (_c = kontrollant.email) !== null && _c !== void 0 ? _c : "";
    const location = (_d = kontrollant.location) !== null && _d !== void 0 ? _d : "";
    const authorizationList = kontrollant.authorizationList.join(" | ");
    const rightsList = kontrollant.rightsList.join(" | ");
    return ((0, jsx_runtime_1.jsxs)("div", { className: "m__article-result", children: [(0, jsx_runtime_1.jsx)("h2", { className: "a-text-normal", children: fullName }), (0, jsx_runtime_1.jsxs)("p", { className: "m__article-result-text", children: [location, " ", (0, jsx_runtime_1.jsx)("br", {}), !!email && (0, jsx_runtime_1.jsx)("a", { href: `mailto:${email}`, children: email }), " ", (0, jsx_runtime_1.jsx)("br", {}), phoneNumber] }), (0, jsx_runtime_1.jsxs)("span", { className: "a-small-label", children: ["Autorisasjoner : " + authorizationList, " ", (0, jsx_runtime_1.jsx)("br", {}), "Rettigheter : " + rightsList, " ", (0, jsx_runtime_1.jsx)("br", {})] })] }, kontrollantId));
};
const renderApp = () => {
    var _a;
    const nodeId = "root-godkjente-kontrollanter";
    const appRootNode = document.getElementById(nodeId);
    if (!appRootNode) {
        console.warn(`Cannot find node with ID '${nodeId}'. The React app cannot be rendered.`);
        return;
    }
    const appData = JSON.parse((_a = appRootNode === null || appRootNode === void 0 ? void 0 : appRootNode.getAttribute("data-react-props")) !== null && _a !== void 0 ? _a : "[]");
    (0, client_1.createRoot)(appRootNode).render(react_1.default.createElement(GodkjenteKontrollanter, {
        kontrollanter: appData,
    }));
};
renderApp();
